import React from 'react';
import { Link, graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import Dropdown from '../dropdown/dropdown';

import './header.scss';

export default ({ location }) => {
  const handleMenuClick = () => {
    const body = document.getElementsByTagName('body')[0];

    if (body.classList.contains('mobile-header__open')) {
      body.classList.remove('mobile-header__open');
    } else {
      body.classList.add('mobile-header__open');
    }
  };

  return (
    <StaticQuery
      query={graphql`
        query HeaderQuery {
          logo: file(relativePath: { eq: "logo.png" }) {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
          facebook: file(relativePath: { eq: "facebook.png" }) {
            childImageSharp {
              fixed(height: 18) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          instagram: file(relativePath: { eq: "instagram.png" }) {
            childImageSharp {
              fixed(height: 18) {
                ...GatsbyImageSharpFixed
              }
            }
          }

          services: allContentfulService {
            edges {
              node {
                name
                slug
              }
            }
          }
        }
      `}
      render={data => (
        <header>
          <div className="header-wrapper">
            <div className="header__title">
              <Link to="/" className="logo">
                <Img className="logo" fluid={data.logo.childImageSharp.fluid}></Img>
              </Link>
              <nav role="navigation">
                <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                  <strong>Home</strong>
                </Link>
                <Link className={location.pathname.includes('servizio') ? 'active' : ''}>
                  <Dropdown
                    activatorText="Servizi e trattamenti"
                    items={data.services.edges.map(edge => {
                      return {
                        name: edge.node.name,
                        link: `/servizio/${edge.node.slug}`,
                      };
                    })}
                  />
                </Link>
                <Link to="/#dove-siamo">
                  <strong>Dove siamo</strong>
                </Link>
                <Link
                  to="/chi-siamo"
                  className={location.pathname === '/chi-siamo' ? 'active' : ''}
                >
                  <strong>Chi siamo</strong>
                </Link>
                <Link to="#contatti">
                  <strong>Contatti</strong>
                </Link>
              </nav>
            </div>

            <div className="social">
              <a
                href="https://www.facebook.com/Spazio-536-studio-estetico--111873243707835/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-logo"
              >
                <Img fixed={data.facebook.childImageSharp.fixed}></Img>
              </a>
              <a
                href="https://www.instagram.com/spazio_536/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-logo"
              >
                <Img fixed={data.instagram.childImageSharp.fixed}></Img>
              </a>
            </div>

            <i onClick={handleMenuClick} className="material-icons">
              menu
            </i>
          </div>
        </header>
      )}
    ></StaticQuery>
  );
};
